'use client'
import dynamic from 'next/dynamic'

// Dynamically import Analytics with client-side only rendering
const Analytics = dynamic(
  () => import('@vercel/analytics/react').then(mod => mod.Analytics),
  { ssr: false }
)

export default function ClientAnalytics() {
  return <Analytics />
} 